import PropTypes from 'prop-types';
import { isNil, mergeRight, pipe, reject } from 'ramda';
import React, { Component } from 'react';

import DateTimePicker from '@/components/DateTimePicker';

const dateFormat = 'Pp';

class DateRangeFilter extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired,
    fromInputProps: PropTypes.object,
    toInputProps: PropTypes.object,
  };

  static defaultProps = {
    fromInputProps: {},
    toInputProps: {},
  };

  handleChange = (key, event) => {
    const { onChange, value } = this.props;
    const date = event.target.value;

    const mergeValue = pipe(mergeRight(value), reject(isNil));

    onChange(mergeValue({ [key]: date }));
  };

  handleChangeFrom = date => this.handleChange('from', date);

  handleChangeTo = date => this.handleChange('to', date);

  render() {
    const { classes, value, fromInputProps, toInputProps } = this.props;
    const from = value.from || null;
    const to = value.to || null;

    return (
      <div>
        <DateTimePicker
          clearable
          label="от"
          className={classes.input}
          format={dateFormat}
          value={from}
          onChange={this.handleChangeFrom}
          {...fromInputProps}
        />
        <DateTimePicker
          clearable
          label="до"
          className={classes.input}
          format={dateFormat}
          value={to}
          onChange={this.handleChangeTo}
          {...toInputProps}
        />
      </div>
    );
  }
}

export default DateRangeFilter;
